export default "__VITE_ASSET__DUXL4pej__"